export default __webpack_public_path__ + "6df9db64e0f9444b980f80c69df1c987.png";